import type { GridColumnHeaderParams } from "@mui/x-data-grid";

import Text from "../atoms/Text";
const DataGridTextHeader = (params: GridColumnHeaderParams) => {
  return (
    <Text variant="body_small" numberOfLines={2}>
      {params.colDef.headerName}
    </Text>
  );
};

export default DataGridTextHeader;
